import { gql, useLazyQuery } from '@apollo/client';
import { useLogger } from '@amzn/xb-hooks';
import { CERTIFICATE_BY_TRANSCRIPT_ID_ERROR } from '../../common/rumMetrics';

export const CERTIFICATE = gql`
    query certificate($transcriptId: ID!) {
        certificate(transcriptId: $transcriptId)
    }
`;

export const useLazyCertificate = () => {
    const { log, count } = useLogger();
    return useLazyQuery(CERTIFICATE, {
        onError: (error) => {
            log.error('Error retrieving certificate by transcript id', error);
            count(CERTIFICATE_BY_TRANSCRIPT_ID_ERROR);
        },
    });
};
